export default "__VITE_ASSET__CWVLURp5__"